import { Environment } from "src/types/environment";

export const environment: Environment = {
  configuration: 'prod',
  appShortName: 'ActiveF',
  licenseServerUrl: 'https://8zzu5991w0.execute-api.eu-west-2.amazonaws.com/Prod/',
  staticDataExpireDurationInMS: 3600000,
  loginHost: "https://test.cloud.incline-it.com",
  cognitoConfig: {
    userPoolId: "eu-west-2_o81HsXJhS",
    userPoolClientId: "1g2k7nda7uddphfm9dg3985f4v",
    loginWith: {
      email: true,
      oauth: {
        domain: "eu-west-2o81hsxjhs.auth.eu-west-2.amazoncognito.com",
        scopes: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
        redirectSignIn: ["https://test.activef.cloud.incline-it.com"],
        redirectSignOut: ["https://test.activef.cloud.incline-it.com"],
        responseType: 'code'
      }
    }
  }
};